import * as _ from 'lodash';
import { FormEvent, useState } from 'react';
import { IXmTracking } from '@nkr/models/index';
import { TableWrapperSmall } from '../styles';
import XmTrackingRow from './row';
import { FormControl } from 'react-bootstrap';

interface IProps {
    list: IXmTracking[],
    centerId: number,
    onUploadFinalXm: (donorId: number, recipientId: number, acceptable: number, rootCause: string, correctiveAction: string, initials: string, upload: File) => void
}

const XmTracking = (props: IProps) => {
    const [showFinalXmUploadId, setShowFinalXmUploadId] = useState(-1);
    const [selectedCenter, setSelectedCenter] = useState(0);

    const handleCenterChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        setSelectedCenter(parseInt(e.currentTarget.value));
    };

    const handleShowFinalXmUpload = (donorId: number, recipientId: number) => {
        let x = props.list.find(x => x.donorId == donorId && x.recipientId == recipientId);
        setShowFinalXmUploadId(x.id);
    };

    const handleCancelShowFinalXmUpload = () => {
        setShowFinalXmUploadId(-1);
    }

    const centerList = _.sortBy(_.uniqBy(props.list.map(x => {
        return {
            id: x.recipientCenterId,
            alias: x.recipientCenterAlias
        };
    }), x => x.id), x => x.alias);

    const filteredList = props.list.filter(x => {
        if (selectedCenter > 0) {
            return x.recipientCenterId == selectedCenter;
        }

        return true;
    });

    return (
        <>
            {props.centerId == 0 && (
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 5 }}>
                    <div style={{ marginRight: 5 }}>Filter by Center:</div>
                    <div>
                        <FormControl
                            componentClass='select'
                            value={selectedCenter}
                            onChange={handleCenterChange}
                        >
                            <option value={0}>- no filter -</option>
                            {centerList.map(item =>
                                <option key={'ctr-' + item.id} value={item.id}>{item.alias}</option>
                            )}
                        </FormControl>
                    </div>
                </div>
            )}

            <div style={{ height: props.list.length > 25 ? 600 : null, overflowY: props.list.length > 25 ? 'scroll' : null }}>
                <TableWrapperSmall className='table table-striped table-condensed table-bordered'>
                    <thead>
                        <tr>
                            <th rowSpan={2}>Swap</th>
                            <th colSpan={2} style={{ borderBottomWidth: 1 }}>Donor</th>
                            <th colSpan={2} style={{ borderBottomWidth: 1 }}>Recipient</th>
                            <th rowSpan={2}>Deadline</th>
                            <th rowSpan={2}>Type</th>
                            <th rowSpan={2}>Status</th>
                            <th rowSpan={2}>Result</th>
                        </tr>
                        <tr>
                            <th style={{ width: '11%' }}>Center</th>
                            <th style={{ width: '11%' }}>Alias</th>
                            <th style={{ width: '11%' }}>Center</th>
                            <th style={{ width: '11%' }}>Alias</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredList.map((item, index) =>
                            <XmTrackingRow
                                key={'xm-' + index}
                                item={item}
                                showUpload={item.id == showFinalXmUploadId}
                                onShowFinalXmUpload={handleShowFinalXmUpload}
                                onCancelShowFinalXmUpload={handleCancelShowFinalXmUpload}
                                onUploadFinalXm={props.onUploadFinalXm}
                            />
                        )}
                    </tbody>
                </TableWrapperSmall>
            </div>
        </>
    );
}

export default XmTracking;